import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { Link } from '@reach/router';

import { Grid, GridCol, Section, TextContainer } from '../../../../components/';

import { ContentSkeleton, ImageSkeleton } from './Skeleton';

import './style.scss';
import { normalizeUrl, localizeUrl } from '../utils';
import { useLocale } from '../../../../modules/Internationalization';

const Post = ({ slug, title, image, excerpt }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(
    () => {
      setIsLoading(true);
    },
    [title]
  );

  const locale = useLocale();

  return (
    <Section space="small" className="post">
      <Link to={localizeUrl(`/blog/${slug}`, locale)}>
        <Grid>
          <GridCol size={{ xs: 26, s: 10, l: 4 }}>
            <img
              src={normalizeUrl(image)}
              alt={title}
              className={isLoading ? 'visually-hidden' : ''}
              onLoad={() => setIsLoading(false)}
            />
            {isLoading && <ImageSkeleton />}
            <div className="mb-small hide-s" />
          </GridCol>
          <GridCol size={{ xs: 26, s: 16, l: 8 }}>
            <TextContainer>
              {isLoading ? (
                <ContentSkeleton />
              ) : (
                <React.Fragment>
                  <h5>{title}</h5>
                  <p>{excerpt}</p>
                </React.Fragment>
              )}
            </TextContainer>
          </GridCol>
        </Grid>
      </Link>
    </Section>
  );
};

Post.propTypes = {
  slug: propTypes.string,
  title: propTypes.string,
  image: propTypes.string,
  excerpt: propTypes.string,
};

export default Post;



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/Post/index.js